"use client";

import { ContainerXL } from "@/common";
import NavigationLink from "@/common/navigation-link.common";
import { usePathname } from "@/i18n/navigation";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslations } from "next-intl";
import LanguageSwitcher from "../language-switcher/language-switcher.component";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { useState, useEffect } from "react";

export const Header = () => {
  const t = useTranslations();
  const translate = useTranslations("Header");
  const isLoggedIn = false;
  const pathname = usePathname();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const drawerContent = (
    <Box 
      className="bg-[#1B5E20] h-full w-64 p-4 text-white"
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <div className="flex justify-between items-center mb-6">
        <Typography variant="h6">Menu</Typography>
        <IconButton onClick={toggleDrawer(false)} className="text-white">
          <CloseIcon />
        </IconButton>
      </div>
      
      <Divider className="bg-white/30 mb-6" />
      
      <div className="flex flex-col gap-6">
        <div>
          <Typography className="mb-2 font-medium">Language</Typography>
          <LanguageSwitcher />
        </div>
        
        {pathname === "/" && !isLoggedIn && (
          <div className="flex flex-col gap-4">
            <Typography className="font-medium">Account</Typography>
            <NavigationLink href="/login">
              <Button 
                variant="outlined" 
                fullWidth 
                className="!text-white !border-white"
              >
                {translate("login")}
              </Button>
            </NavigationLink>
            <NavigationLink href="/register">
              <Button 
                variant="contained" 
                fullWidth
                className="!bg-white !text-[#1B5E20]"
              >
                {translate("register")}
              </Button>
            </NavigationLink>
          </div>
        )}
      </div>
    </Box>
  );

  return (
    <div className="bg-[#1B5E20] w-full m-0 fixed z-20">
      <ContainerXL className="flex justify-between py-3">
        <div className="flex gap-3 items-center">
          <NavigationLink href="/">
            <img src="/District Nagpur.png" alt={t("Forest Logo")} width={90} height={90} className="rounded-sm" />
          </NavigationLink>
          <NavigationLink href="/">
            <Typography sx={{
              fontSize: { xs: "1.25rem", md: "1.5rem" },
              color: "white"
            }}>
              {t("HaritWeg")}
            </Typography>
          </NavigationLink>
        </div>

        {/* Desktop menu */}
        <div className="hidden md:flex gap-8 items-center">
          <LanguageSwitcher />
          {pathname === "/" && !isLoggedIn && (
            <>
              <NavigationLink href="/login">
                <Button variant="text" className="!text-white">
                  {translate("login")}
                </Button>
              </NavigationLink>

              <NavigationLink href="/register">
                <Button variant="contained" className="!bg-white !text-[#1B5E20]">
                  {translate("register")}
                </Button>
              </NavigationLink>
            </>
          )}
        </div>

        {/* Mobile menu button */}
        <div className="flex md:hidden items-center">
          <IconButton 
            edge="end" 
            color="inherit" 
            aria-label="menu" 
            onClick={toggleDrawer(true)}
            className="text-white"
          >
            <MenuIcon />
          </IconButton>
        </div>
      </ContainerXL>

      {/* Mobile drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
      >
        {drawerContent}
      </Drawer>
    </div>
  );
};

export default Header;